import { useMemo } from 'react';

import { ALTERNATIVES, PLASTICS } from '../Data';
import { Item } from '../Types';
import useCo2Calculation from './useCo2Calculation';

// @ts-ignore
const f = (a, b) => [].concat(...a.map(a => b.map(b => [].concat(a, b))));
// @ts-ignore
const cartesianProduct = (a, b, ...c) => b ? cartesianProduct(f(a, b), ...c) : a;

interface Params {
    items: Item[];
}

const useSavingScore = (params: Params) => {
    const { items } = params;

    const savingsList = useMemo(() => {
        const cartesian = cartesianProduct(PLASTICS, ALTERNATIVES);

        const savingMatrix = cartesian.map((item: any) => {
            return { item, saving: (item[0].value - item[1].value) / item[0].value };
        }).sort((item1: any, item2: any) => {
            return item1.saving - item2.saving;
        });

        const savings: number[] = [];

        for (const item of savingMatrix) {
            if (!savings.includes(item.saving)) {
                savings.push(item.saving);
            }
        }

        return savings;
    }, []);

    const initialCo2 = useCo2Calculation({ items, type: 'initial' });

    const finalCo2 = useCo2Calculation({ items, type: 'final' });

    const percentageSave = (initialCo2 - finalCo2) / initialCo2;
    let percentageIndex = 0;

    for (let index = 0; index < savingsList.length; index++) {
        const saving = savingsList[index];

        if (saving >= percentageSave) {
            percentageIndex = index;
            break;
        }
    }

    return Math.round(1 + percentageIndex / (savingsList.length / 3));
};

export default useSavingScore;
